import script from "./RequestAccountUnsubscribeView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RequestAccountUnsubscribeView.vue?vue&type=script&lang=ts&setup=true"

import "./RequestAccountUnsubscribeView.vue?vue&type=style&index=0&id=05b223f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05b223f4"]])

export default __exports__